import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Col, Image, Offcanvas } from "react-bootstrap";
import IMAGES from "constants/images";
import VendorMenu from "pages/vendorpanel/components/sidebar";
import { useAuth } from "context/UserContext";
import { useFetchProfile } from "hooks/useFetchProfile";
const VendorSidebar = ({ showFollowers, setShowFollowers }) => {
  const { user} = useAuth();
  const handleShowFollowers = () => {
    setShow(false);
    setShowFollowers(true);
  };
  const [activeVendorTab, setActiveVendorTab] = useState(0);
  const [show, setShow] = useState(false);

  
  return (
    <>
      <div className="showSideMobil">
        <div onClick={() => setShow(true)}>
          <Icon icon="stash:filter-light" color="#ffffff" fontSize={25} />
        </div>
      </div>
      {/* Sidebar */}
      <Col  className="hide1199"  style={{width: "100%",height: "max-content"}}>
        <div className="profile-sidebar">
          <div className="profile-sidebar-image">
          <Image
                      style={{ width: 80, height: 80 }}
                      src={user?.profileUrl || IMAGES.User2_Img}
                      roundedCircle
                    />
            <div onClick={handleShowFollowers} className="cursor-pointer">
            <h3>{user?.followersCount || "0"}</h3>
            <p>Followers</p>
            </div>
            <div onClick={handleShowFollowers} className="cursor-pointer">
            <h3>{user?.followingCount || "0"}</h3>
            <p>Following</p>
            </div>
          </div>
          <h5> {user?.firstName} {user?.lastName}</h5>
          <p className="text-muted">{user?.email}</p>
          <div className="divider"></div>
          <VendorMenu
          setShowFollowers={setShowFollowers}
            activeVendorTab={activeVendorTab}
            handleVendorTabClick={(id) => setActiveVendorTab(id)}
          />
        </div>
      </Col>
      <Offcanvas show={show} onHide={() => setShow(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="showSideMobilContent">
          <div className="profile-sidebar">
            <div className="profile-sidebar-image">
            <Image
                      style={{ width: 80, height: 80 }}
                      src={user?.profileUrl || IMAGES.User2_Img}
                      roundedCircle
                    />
              <div onClick={handleShowFollowers} className="cursor-pointer">
              <h3>{user?.followersCount || "0"}</h3>
              <p>Followers</p>
              </div>
              <div onClick={handleShowFollowers} className="cursor-pointer">
              <h3>{user?.followingCount || "0"}</h3>
              <p>Following</p>
              </div>
            </div>
            <h5>{user?.firstName} {user?.lastName}</h5>
            <p className="text-muted">{user?.email}</p>
            <div className="divider"></div>
            <VendorMenu
             setShowFollowers={setShowFollowers}
              activeVendorTab={activeVendorTab}
              handleVendorTabClick={(id) => setActiveVendorTab(id)}
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default VendorSidebar;
